import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

interface CreateFolderModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
  parentName?: string; // Optional: Name of the parent folder for context
}

const CreateFolderModal: React.FC<CreateFolderModalProps> = ({
  open,
  onClose,
  onSubmit,
  parentName,
}) => {
  const [name, setName] = useState('Untitled Folder');

  // Reset name when modal opens
  useEffect(() => {
    if (open) {
      setName('Untitled Folder');
    }
  }, [open]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleSubmit = () => {
    if (name.trim()) { // Only submit if name is not just whitespace
      onSubmit(name.trim());
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Create New Folder {parentName ? `in '${parentName}'` : 'at Root'}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Folder Name"
          type="text"
          fullWidth
          variant="standard"
          value={name}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={!name.trim()}>Create</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFolderModal; 